if (!customElements.get('piecework-media-gallery')) {
  customElements.define(
    'piecework-media-gallery',
    class PieceworkMediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          slideshow: this.querySelector('.splide'),
          thumbnails: this.querySelectorAll('.pw-media-thumbnails button'),
          pagination: this.querySelectorAll('.pw-media-pagination div'),
          slides: this.querySelectorAll('.splide li'),
          //   slideshowContainer: this.querySelector('.more-from-slideshow-container'),
          //   slides: this.querySelectorAll('li'),
          //   controls: {
          //     prev: this.querySelector('[data-prev]'),
          //     next: this.querySelector('[data-next]'),
          //   },
          //   announcement: this.querySelector('[aria-live="polite"]'),
        };
        // this.loaded = false;
        // this.slide = 1;
        // this.slideWidth = this.elements.slides[0].offsetWidth;
        // // this.mql = window.matchMedia('(min-width: 750px)');
        // if (!this.elements.slides) return;

        // // this.elements.controls.addEventListener('click', this.togglePlaying.bind(this));
        // window.addEventListener('resize', this.resizeSlideshow.bind(this));

        // this.elements.controls.prev.addEventListener('click', this.changeSlide.bind(this, 'prev'));
        // this.elements.controls.next.addEventListener('click', this.changeSlide.bind(this, 'next'));
      }

      setActiveMedia(media, bool) {
        this.elements.slides.forEach((slide) => {
          const target = slide.dataset.target;
          if (media === target) {
            const slideNum = parseInt(slide.dataset.slide);
            this.slider.go(slideNum);
          }
        });
      }

      connectedCallback() {
        setTimeout(() => {
          this.slider = new Splide(this.elements.slideshow, {
            type: 'loop',
            //   arrows: false,
            pagination: false,
            // trimSpace: true,
            speed: 600,
          }).mount();
          this.slider.go(0);
          if (this.elements.thumbnails) {
            this.elements.thumbnails.forEach((thumb) => {
              thumb.addEventListener('click', () => {
                const slide = parseInt(thumb.dataset.slide);
                this.slider.go(slide);
              });
            });
          }

          this.slider.on('move', () => {
            if (this.elements.thumbnails) {
              this.elements.thumbnails.forEach((thumb) => {
                const slide = parseInt(thumb.dataset.slide);
                if (this.slider.index === slide) {
                  thumb.setAttribute('aria-selected', 'true');
                  thumb.disabled = true;
                } else {
                  thumb.setAttribute('aria-selected', 'false');
                  thumb.disabled = false;
                }
              });
            }

            this.elements.slides.forEach((slide) => {
              const slideNum = parseInt(slide.dataset.slide);
              if (this.slider.index === slideNum) {
                const video = slide.querySelector('video');
                if (video) {
                  video.play();
                }
              } else {
                const video = slide.querySelector('video');
                if (video) {
                  video.pause();
                  video.currentTime = 0;
                }
              }
            });

            if (this.elements.pagination) {
              this.elements.pagination.forEach((page) => {
                const slide = parseInt(page.dataset.slide);
                if (this.slider.index === slide) {
                  page.classList.add('tw-bg-current');
                } else {
                  page.classList.remove('tw-bg-current');
                }
              });
            }
          });
        }, 500);
      }
    }
  );
}
